module.exports = __webpack_public_path__ + "static/media/web-development.1c04faaf.png";